import { GetServerSidePropsContext } from 'next';

import { Locale } from '@silvertours/back-domain-sitegroup';
import { SearchWidgetPageServerSideRequest } from '@silvertours/back-runtime-landingpages';
import { LandingPageLegacy } from '@silvertours/front-pages';

export const getServerSideProps = (nextContext: GetServerSidePropsContext) => {
  const handler = new SearchWidgetPageServerSideRequest(
    'affiliate',
    Locale.German.value,
  );

  return handler.getServerSideProps(nextContext);
};

export default LandingPageLegacy.AffiliatePage;
